//获取管理后台令牌
const getBackendToken = `/gateway/blade-user/user/getBackendToken`;
export {
 getBackendToken
};
